<template>
  <div class="container about">
    <!-- <h1>这是下载页面</h1> -->

    <div class="panel">
      <h2>APP下载</h2>
      <h3><img class="icon-logo" src="@/assets/icon-apple.png" alt="IOS系统">IOS系统下载 <small>若遇到无法在平板直接安装，可以在电脑端下载对应版本离线包，并在电脑上安装爱思助手，离线安装App。</small></h3>
      <ul class="nav">
        <li>
          <span class="title">站外引导</span>
          <span class="links">
            <a v-for="(item,index) in list_iOS_station_out" :key="index" :href="item.url">{{ item.txt }}</a>
          </span>
        </li>
        <li>
          <span class="title">手持评分</span>
          <span class="links">
            <a v-for="(item,index) in list_iOS_hand_score" :key="index" :href="item.url">{{ item.txt }}</a>
		  </span>
        </li>
        <li >
          <span class="title">随  时  练</span>
			<span class="links">            
            <a v-for="(item,index) in list_iOS_practice" :key="index" :href="item.url">{{ item.txt }}</a>
          </span>
        </li>
		<li >
          <span class="title">天堰资源管理</span>
			<span class="links">            
            <a v-for="(item,index) in list_iOS_resource" :key="index" :href="item.url">{{ item.txt }}</a>    
          </span>
        </li>
		<li >
		  <span class="title">实训管理端</span>
			<span class="links">            
			<a v-for="(item,index) in list_iOS_storm_manager" :key="index" :href="item.url">{{ item.txt }}</a>    
		  </span>
		</li>
		<li >
		  <span class="title">实训学生端</span>
			<span class="links">            
			<a v-for="(item,index) in list_iOS_storm_student" :key="index" :href="item.url">{{ item.txt }}</a>    
		  </span>
		</li>
    <li >
      <span class="title">实训App</span>
        <span class="links">            
        <a v-for="(item,index) in list_iOS_storm" :key="index" :href="item.url">{{ item.txt }}</a>    
      </span>
		</li>
      </ul>

      <div class="hr"></div>

      <h3><img class="icon-logo" src="@/assets/icon-android.png" alt="安卓系统">安卓系统下载</h3>
      <ul class="nav">
        <li>
          <span class="title">站外引导</span>
          <span class="links">
            <a v-for="(item,index) in list_android_station_out" :key="index" :href="item.url">{{ item.txt }}</a>						
          </span>
        </li>
        <li>
          <span class="title">手持评分</span>
          <span class="links">
            <a v-for="(item,index) in list_android_hand_score" :key="index" :href="item.url">{{ item.txt }}</a>

          </span>
        </li>		
        <li>
          <span class="title">随  时  练</span>
	  <span class="links">            
            <a v-for="(item,index) in list_android_practice" :key="index" :href="item.url">{{ item.txt }}</a>  
          </span>
        </li>	
		<li>
			<span class="title">天堰资源管理</span>
			<span class="links">            
				<a v-for="(item,index) in list_android_resource" :key="index" :href="item.url">{{ item.txt }}</a>						   
			</span>
		</li>	
		<li >
		<span class="title">实训管理端</span>
			<span class="links">            
			<a v-for="(item,index) in list_android_storm_manager" :key="index" :href="item.url">{{ item.txt }}</a>    
		</span>
		</li>
		<li >
		<span class="title">实训学生端</span>
			<span class="links">            
			<a v-for="(item,index) in list_android_storm_student" :key="index" :href="item.url">{{ item.txt }}</a>    
		</span>
		</li>
		<li >
		<span class="title">电子门牌</span>
			<span class="links">            
			<a v-for="(item,index) in list_android_e_door" :key="index" :href="item.url">{{ item.txt }}</a>    
		</span>
		</li>
		<li >
      <span class="title">简报</span>
        <span class="links">            
        <a v-for="(item,index) in list_android_simple" :key="index" :href="item.url">{{ item.txt }}</a>    
      </span>
		</li>
    <li >
      <span class="title">电子考试</span>
        <span class="links">            
        <a v-for="(item,index) in list_android_etest" :key="index" :href="item.url">{{ item.txt }}</a>    
      </span>
		</li>
    <li >
      <span class="title">实训App</span>
        <span class="links">            
        <a v-for="(item,index) in list_android_storm" :key="index" :href="item.url">{{ item.txt }}</a>    
      </span>
		</li>
      </ul>
    </div>

    <div class="panel">
      <h2>IOS安装说明</h2>
      <p>1.根据安装的服务端版本（点击登录页的关于我们）如图1，下载对应的APP版本 图2，在系统的【设置-通用-设备管理】进行信任设置。</p>
      <p class="image-group">
        <a class="group1" href="img/download/install_1_1.png" title="查看服务端版本"><img src="img/download/install_1_1.png" alt="查看服务端版本"></a>
        <a class="group1" href="img/download/install_1_2.png" title="安装对应的客户端"><img src="img/download/install_1_2.png" alt="安装对应的客户端"></a>
        <a class="group1" href="img/download/install_1_3.png" title="IOS需要安装证书"><img src="img/download/install_1_3.png" alt="IOS需要安装证书"></a>
      </p>
    </div>
  </div>
</template>

<script>
import "jquery-colorbox/example3/colorbox.css";
import "jquery-colorbox/jquery.colorbox-min.js";
import "jquery-colorbox/i18n/jquery.colorbox-zh-CN.js";

export default {
  name: "download",
  mounted: function() {
    $(".group1").colorbox({rel: "group1", maxWidth:"90%", maxHeight:"90%"});
	this.getDownFileInfo();
  },
  data() {
  	return {
		vs: "saaas",
		list: [],
		list_iOS_station_out:[],
		list_iOS_hand_score:[],
		list_iOS_practice:[],
		list_iOS_resource:[],
		list_iOS_storm_manager:[],
		list_iOS_storm_student:[],
    list_iOS_storm:[],
		list_android_station_out:[],
		list_android_hand_score:[],
		list_android_practice:[],
		list_android_resource:[],
		list_android_storm_manager:[],
		list_android_storm_student:[],
		list_android_e_door:[],
		list_android_simple:[],
    list_android_etest:[],
    list_android_storm:[]
  	};
  },
  methods: {
	  getDownFileInfo: function()
	  {
// 	  		this.$axios.get('../../public/downfile.json').then((res) => {
               //console.log(ss)
//             });
			//debugger;
			this.$axios.get('downfile.json').then((res) => {
              //console.log(res.data[0].txt)
			  this.list_iOS_station_out = res.data.iOS_station_out;
			  this.list_iOS_hand_score = res.data.iOS_hand_score;
			  this.list_iOS_practice = res.data.iOS_practice;
			  this.list_iOS_resource = res.data.iOS_resource;
			  this.list_iOS_storm_manager = res.data.iOS_storm_manager;
			  this.list_iOS_storm_student = res.data.iOS_storm_student;
			  
			  this.list_android_station_out = res.data.android_station_out;
			  this.list_android_hand_score = res.data.android_hand_score;
			  this.list_android_practice = res.data.android_practice;
			  this.list_android_resource = res.data.android_resource;
			  this.list_android_storm_manager = res.data.android_storm_manager;
			  this.list_android_storm_student = res.data.android_storm_student;
			  this.list_android_e_door = res.data.android_e_door;
				this.list_android_simple = res.data.android_simple;
        this.list_android_etest = res.data.android_etest;

        this.list_iOS_storm = res.data.iOS_storm;
        this.list_android_storm = res.data.android_storm;
			  
            });
	  }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .panel {
  padding: 20px 100px;

  h2 {
    font-size: 36px;
    font-weight: 400;
    text-align: center;
  }

  h3 small {
    margin-left: 40px;
    font-weight: 300;
  }

  h3, span.title {
    color: #777;
  }

  .nav li {
    min-height: 40px;
    line-height: 40px;

    span.title {
      display: inline-block;
      margin-right: 50px;
      width: 160px;
      font-weight: 800;
      text-align: right;
    }

    span.links {
      display: inline-block;
      width: calc(100% - 220px);
      vertical-align: top;
    }

    span.links a {
      display: inline-block;
      margin-right: 30px;
      // width: 90px;
    }
  }

  .icon-logo {
    width: 40px;
    margin-right: 15px;
    vertical-align: bottom;
  }

  .image-group {
    padding-left: 20px;

    a { margin-right: 15px; }
    img { height: 220px; }
  }

  .hr {
    margin: 30px 0;
    height: 2px;
    background-image: linear-gradient(to right, #f8f8f8 0%, #ddd 50%,#f8f8f8 100%);;
  }
}
</style>